import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
} from "@mui/material";
import React from "react";

const Faq = () => {
  return (
    <div className="flex flex-col md:flex-row w-full justify-evenly bg-[#1d1d1d] md:px-20 text-center md:text-left text-white">
      <div className="flex flex-col w-full md:w-1/2 justify-evenly py-10">
        <div className="font-HNbold text-3xl">FAQ</div>
        <div className="font-HNbold text-3xl md:text-5xl py-6">
          Do you have any
          <br /> Questions for us ?
        </div>
        <div className="font-HNlight text-xl text-[#ffffff9b]">
          We would be delighted to <br />
          answer you!
        </div>
        <Button
          onClick={() => {
            window.location.href = "#";
          }}
          variant="contained"
          sx={{
            borderRadius: 10,
            marginY: 4,
            width: "60%",
            marginLeft: 0,
            backgroundColor: "#1264FF",
          }}
        >
          ASK
        </Button>
      </div>
      <div className="mx-auto md:p-10 w-3/5 flex flex-col justify-center">
        <Accordion
          style={{
            color: "whitesmoke",
            backgroundColor: "#1d1d1d",
            borderBottomColor: "grey",
            borderBottomWidth: "2px",
          }}
        >
          <AccordionSummary
            sx={{ fontSize: { xs: "16px", md: "20px" } }}
            expandIcon={<ExpandMore sx={{ color: "whitesmoke" }} />}
            aria-controls="panel1-content"
            id="panel1-header"
            style={{ borderBottom: 2, borderBottomColor: "grey" }}
          >
            What types of plastic caps do you manufacture?
          </AccordionSummary>
          <AccordionDetails sx={{ fontSize: { xs: "13px", md: "17px" } }}>
            We manufacure caps and enclosures for pastic conainers. Please
            checkout our products page to know more about our products and
            services
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            color: "whitesmoke",
            backgroundColor: "#1d1d1d",
            borderBottomColor: "grey",
            borderBottomWidth: "2px",
          }}
        >
          <AccordionSummary
            sx={{ fontSize: { xs: "16px", md: "20px" } }}
            expandIcon={<ExpandMore sx={{ color: "whitesmoke" }} />}
            aria-controls="panel1-content"
            id="panel1-header"
            style={{ borderBottom: 2, borderBottomColor: "grey" }}
          >
            What industries do you cater to with your plastic caps?
          </AccordionSummary>
          <AccordionDetails sx={{ fontSize: { xs: "13px", md: "17px" } }}>
            We specialize in the fabrication of high-quality cap and enclosure
            solutions tailored for a diverse array of industries, including oil,
            water, dairy, and pharmaceutical containers.
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            color: "whitesmoke",
            borderBottomColor: "grey",
            borderBottomWidth: "2px",
            backgroundColor: "#1d1d1d",
          }}
        >
          <AccordionSummary
            sx={{ fontSize: { xs: "16px", md: "20px" } }}
            expandIcon={<ExpandMore sx={{ color: "whitesmoke" }} />}
            aria-controls="panel1-content"
            id="panel1-header"
            style={{ borderBottom: 2, borderBottomColor: "grey" }}
          >
            Do you offer customization options for plastic caps?
          </AccordionSummary>
          <AccordionDetails sx={{ fontSize: { xs: "13px", md: "17px" } }}>
            Yes. We do manufacture plastic caps with customization. Place a{" "}
            <a href="#" className="text-blue-500">
              product enquiry
            </a>{" "}
            and our team will reach out to you.
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            color: "whitesmoke",
            borderBottomColor: "grey",
            borderBottomWidth: "2px",
            backgroundColor: "#1d1d1d",
          }}
        >
          <AccordionSummary
            sx={{ fontSize: { xs: "16px", md: "20px" } }}
            expandIcon={<ExpandMore sx={{ color: "whitesmoke" }} />}
            aria-controls="panel1-content"
            id="panel1-header"
            style={{ borderBottom: 2, borderBottomColor: "grey" }}
          >
            What are your minimum order quantities for plastic caps?
          </AccordionSummary>
          <AccordionDetails sx={{ fontSize: { xs: "13px", md: "17px" } }}>
            Minimum order quantity varies from product to product. Feel free to{" "}
            <a href="#" className="text-blue-500">
              get in touch{" "}
            </a>
            with us to get a personalized quote
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};
export default Faq;
